/**
* This file was @generated using pocketbase-typegen
*/

import type PocketBase from 'pocketbase'
import type { RecordService } from 'pocketbase'

export enum Collections {
	Authorigins = "_authOrigins",
	Externalauths = "_externalAuths",
	Mfas = "_mfas",
	Otps = "_otps",
	Superusers = "_superusers",
	AdjustmentRequests = "adjustment_requests",
	BookQuestions = "book_questions",
	BookSummaries = "book_summaries",
	Books = "books",
	Leaderboard = "leaderboard",
	PointLogs = "point_logs",
	Questions = "questions",
	Sections = "sections",
	Sources = "sources",
	Summaries = "summaries",
	TeacherPointDistributions = "teacher_point_distributions",
	UserScore = "user_score",
	Users = "users",
}

// Alias types for improved usability
export type IsoDateString = string
export type IsoAutoDateString = string & { readonly autodate: unique symbol }
export type RecordIdString = string
export type FileNameString = string & { readonly filename: unique symbol }
export type HTMLString = string

type ExpandType<T> = unknown extends T
	? T extends unknown
		? { expand?: unknown }
		: { expand: T }
	: { expand: T }

// System fields
export type BaseSystemFields<T = unknown> = {
	id: RecordIdString
	collectionId: string
	collectionName: Collections
} & ExpandType<T>

export type AuthSystemFields<T = unknown> = {
	email: string
	emailVisibility: boolean
	username: string
	verified: boolean
} & BaseSystemFields<T>

// Record types for each collection

export type AuthoriginsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	fingerprint: string
	id: string
	recordRef: string
	updated: IsoAutoDateString
}

export type ExternalauthsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	provider: string
	providerId: string
	recordRef: string
	updated: IsoAutoDateString
}

export type MfasRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	method: string
	recordRef: string
	updated: IsoAutoDateString
}

export type OtpsRecord = {
	collectionRef: string
	created: IsoAutoDateString
	id: string
	password: string
	recordRef: string
	sentTo?: string
	updated: IsoAutoDateString
}

export type SuperusersRecord = {
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	id: string
	password: string
	tokenKey: string
	updated: IsoAutoDateString
	verified?: boolean
}

export type AdjustmentRequestsRecord = {
	amount_adjusted?: number
	amount_requested: number
	created: IsoAutoDateString
	error?: string
	id: string
	idempotency_key: string
	new_balance?: number
	previous_balance?: number
	reason: string
	success: boolean
	updated: IsoAutoDateString
	user: RecordIdString
}

export enum BookQuestionsTypeOptions {
	"MCQ" = "MCQ",
	"LO" = "LO",
	"HO" = "HO",
}
export type BookQuestionsRecord<Tchoices = unknown, Tlo_answers = unknown> = {
	answer?: string
	book_summary?: RecordIdString
	choices?: null | Tchoices
	created: IsoAutoDateString
	id: string
	lo_answers?: null | Tlo_answers
	question?: string
	type?: BookQuestionsTypeOptions
	updated: IsoAutoDateString
}

export type BookSummariesRecord = {
	book?: RecordIdString
	created: IsoAutoDateString
	id: string
	summary?: string
	updated: IsoAutoDateString
}

export enum BooksPhaseOptions {
	"initial" = "initial",
	"searching" = "searching",
	"searched" = "searched",
	"downloading" = "downloading",
	"downloaded" = "downloaded",
	"processing" = "processing",
	"processed" = "processed",
	"error" = "error",
}

export enum BooksActionOptions {
	"search" = "search",
	"download" = "download",
	"process" = "process",
	"retry" = "retry",
	"reset" = "reset",
}

export enum BooksErrorPhaseOptions {
	"search" = "search",
	"metadata_download" = "metadata_download",
	"cover_download" = "cover_download",
	"epub_download" = "epub_download",
	"summarization" = "summarization",
	"question_generation" = "question_generation",
}
export type BooksRecord = {
	action?: BooksActionOptions
	author?: string
	book?: FileNameString
	cover?: FileNameString
	cover_downloaded?: boolean
	created: IsoAutoDateString
	download_url?: string
	downloaded_at?: IsoDateString
	epub_downloaded?: boolean
	error_message?: string
	error_phase?: BooksErrorPhaseOptions
	extension?: string
	field?: string
	file_size?: string
	id: string
	isbn?: string
	language?: string
	lexile_level?: number
	md5?: string
	metadata_downloaded?: boolean
	original_cover_url?: string
	phase: BooksPhaseOptions
	processed_at?: IsoDateString
	questions_generated?: boolean
	retry_count?: number
	search_completed?: boolean
	searched_at?: IsoDateString
	slug?: string
	summarized?: boolean
	title?: string
	updated: IsoAutoDateString
	user_title?: string
	word_count?: number
}

export type LeaderboardRecord<TlastScoreTime = unknown> = {
	fullName?: string
	id: string
	lastScoreTime?: null | TlastScoreTime
	user?: RecordIdString
	weeklyScore?: number
}

export type PointLogsRecord = {
	amount: number
	created: IsoAutoDateString
	id: string
	reason: string
	updated: IsoAutoDateString
	user: RecordIdString
}

export enum QuestionsTypeOptions {
	"MCQ" = "MCQ",
	"LO" = "LO",
	"HO" = "HO",
}

export enum QuestionsLexicalOptions {
	"BEGINNER" = "BEGINNER",
	"INTERMEDIATE" = "INTERMEDIATE",
	"ADVANCED" = "ADVANCED",
}
export type QuestionsRecord<Tchoices = unknown, Tlo_answers = unknown> = {
	answer?: string
	choices?: null | Tchoices
	created: IsoAutoDateString
	id: string
	lexical?: QuestionsLexicalOptions
	lo_answers?: null | Tlo_answers
	question?: string
	summary?: RecordIdString
	type?: QuestionsTypeOptions
	updated: IsoAutoDateString
}

export type SectionsRecord = {
	created: IsoAutoDateString
	id: string
	image?: FileNameString
	name?: string
	updated: IsoAutoDateString
}

export enum SourcesStatusOptions {
	"inbox" = "inbox",
	"denied" = "denied",
	"processed" = "processed",
	"expired" = "expired",
}
export type SourcesRecord = {
	abstract?: string
	created: IsoAutoDateString
	denied_reason?: string
	id: string
	newsdata_id?: string
	published_date?: IsoDateString
	section?: RecordIdString
	slug?: string
	source_type?: string
	status?: SourcesStatusOptions
	title?: string
	updated: IsoAutoDateString
	url?: string
	word_count?: number
}

export type SummariesRecord = {
	advanced?: string
	beginner?: string
	created: IsoAutoDateString
	id: string
	intermediate?: string
	original?: string
	reported?: number
	source?: RecordIdString
	updated: IsoAutoDateString
}

export type TeacherPointDistributionsRecord = {
	amount: number
	created: IsoAutoDateString
	id: string
	student: RecordIdString
	teacher: RecordIdString
	updated: IsoAutoDateString
}

export type UserScoreRecord = {
	article?: RecordIdString
	book?: RecordIdString
	correct_answers?: number
	created: IsoAutoDateString
	id: string
	lexile_level?: number
	score?: number
	time_spent?: number
	total_questions?: number
	updated: IsoAutoDateString
	user?: RecordIdString
}

export enum UsersRoleOptions {
	"student" = "student",
	"teacher" = "teacher",
}

export enum UsersGenderOptions {
	"male" = "male",
	"female" = "female",
}
export type UsersRecord = {
	access_shop?: boolean
	avatar?: FileNameString
	birthdate?: IsoDateString
	created: IsoAutoDateString
	email: string
	emailVisibility?: boolean
	gender?: UsersGenderOptions
	id: string
	name?: string
	password: string
	points_balance?: number
	points_to_distribute?: number
	points_updated_at?: IsoDateString
	reading_power?: number
	reading_power_last_calculated?: IsoDateString
	role: UsersRoleOptions
	tokenKey: string
	updated: IsoAutoDateString
	username: string
	verified?: boolean
}

// Response types include system fields and match responses from the PocketBase API
export type AuthoriginsResponse<Texpand = unknown> = Required<AuthoriginsRecord> & BaseSystemFields<Texpand>
export type ExternalauthsResponse<Texpand = unknown> = Required<ExternalauthsRecord> & BaseSystemFields<Texpand>
export type MfasResponse<Texpand = unknown> = Required<MfasRecord> & BaseSystemFields<Texpand>
export type OtpsResponse<Texpand = unknown> = Required<OtpsRecord> & BaseSystemFields<Texpand>
export type SuperusersResponse<Texpand = unknown> = Required<SuperusersRecord> & AuthSystemFields<Texpand>
export type AdjustmentRequestsResponse<Texpand = unknown> = Required<AdjustmentRequestsRecord> & BaseSystemFields<Texpand>
export type BookQuestionsResponse<Tchoices = unknown, Tlo_answers = unknown, Texpand = unknown> = Required<BookQuestionsRecord<Tchoices, Tlo_answers>> & BaseSystemFields<Texpand>
export type BookSummariesResponse<Texpand = unknown> = Required<BookSummariesRecord> & BaseSystemFields<Texpand>
export type BooksResponse<Texpand = unknown> = Required<BooksRecord> & BaseSystemFields<Texpand>
export type LeaderboardResponse<TlastScoreTime = unknown, Texpand = unknown> = Required<LeaderboardRecord<TlastScoreTime>> & BaseSystemFields<Texpand>
export type PointLogsResponse<Texpand = unknown> = Required<PointLogsRecord> & BaseSystemFields<Texpand>
export type QuestionsResponse<Tchoices = unknown, Tlo_answers = unknown, Texpand = unknown> = Required<QuestionsRecord<Tchoices, Tlo_answers>> & BaseSystemFields<Texpand>
export type SectionsResponse<Texpand = unknown> = Required<SectionsRecord> & BaseSystemFields<Texpand>
export type SourcesResponse<Texpand = unknown> = Required<SourcesRecord> & BaseSystemFields<Texpand>
export type SummariesResponse<Texpand = unknown> = Required<SummariesRecord> & BaseSystemFields<Texpand>
export type TeacherPointDistributionsResponse<Texpand = unknown> = Required<TeacherPointDistributionsRecord> & BaseSystemFields<Texpand>
export type UserScoreResponse<Texpand = unknown> = Required<UserScoreRecord> & BaseSystemFields<Texpand>
export type UsersResponse<Texpand = unknown> = Required<UsersRecord> & AuthSystemFields<Texpand>

// Types containing all Records and Responses, useful for creating typing helper functions

export type CollectionRecords = {
	_authOrigins: AuthoriginsRecord
	_externalAuths: ExternalauthsRecord
	_mfas: MfasRecord
	_otps: OtpsRecord
	_superusers: SuperusersRecord
	adjustment_requests: AdjustmentRequestsRecord
	book_questions: BookQuestionsRecord
	book_summaries: BookSummariesRecord
	books: BooksRecord
	leaderboard: LeaderboardRecord
	point_logs: PointLogsRecord
	questions: QuestionsRecord
	sections: SectionsRecord
	sources: SourcesRecord
	summaries: SummariesRecord
	teacher_point_distributions: TeacherPointDistributionsRecord
	user_score: UserScoreRecord
	users: UsersRecord
}

export type CollectionResponses = {
	_authOrigins: AuthoriginsResponse
	_externalAuths: ExternalauthsResponse
	_mfas: MfasResponse
	_otps: OtpsResponse
	_superusers: SuperusersResponse
	adjustment_requests: AdjustmentRequestsResponse
	book_questions: BookQuestionsResponse
	book_summaries: BookSummariesResponse
	books: BooksResponse
	leaderboard: LeaderboardResponse
	point_logs: PointLogsResponse
	questions: QuestionsResponse
	sections: SectionsResponse
	sources: SourcesResponse
	summaries: SummariesResponse
	teacher_point_distributions: TeacherPointDistributionsResponse
	user_score: UserScoreResponse
	users: UsersResponse
}

// Utility types for create/update operations

type ProcessCreateAndUpdateFields<T> = Omit<{
	// Omit AutoDate fields
	[K in keyof T as Extract<T[K], IsoAutoDateString> extends never ? K : never]: 
		// Convert FileNameString to File
		T[K] extends infer U ? 
			U extends (FileNameString | FileNameString[]) ? 
				U extends any[] ? File[] : File 
			: U
		: never
}, 'id'>

// Create type for Auth collections
export type CreateAuth<T> = {
	id?: RecordIdString
	email: string
	emailVisibility?: boolean
	password: string
	passwordConfirm: string
	verified?: boolean
} & ProcessCreateAndUpdateFields<T>

// Create type for Base collections
export type CreateBase<T> = {
	id?: RecordIdString
} & ProcessCreateAndUpdateFields<T>

// Update type for Auth collections
export type UpdateAuth<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof AuthSystemFields>
> & {
	email?: string
	emailVisibility?: boolean
	oldPassword?: string
	password?: string
	passwordConfirm?: string
	verified?: boolean
}

// Update type for Base collections
export type UpdateBase<T> = Partial<
	Omit<ProcessCreateAndUpdateFields<T>, keyof BaseSystemFields>
>

// Get the correct create type for any collection
export type Create<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? CreateAuth<CollectionRecords[T]>
		: CreateBase<CollectionRecords[T]>

// Get the correct update type for any collection
export type Update<T extends keyof CollectionResponses> =
	CollectionResponses[T] extends AuthSystemFields
		? UpdateAuth<CollectionRecords[T]>
		: UpdateBase<CollectionRecords[T]>

// Type for usage with type asserted PocketBase instance
// https://github.com/pocketbase/js-sdk#specify-typescript-definitions

export type TypedPocketBase = {
	collection<T extends keyof CollectionResponses>(
		idOrName: T
	): RecordService<CollectionResponses[T]>
} & PocketBase
